import { Box, Grid, Heading, Text } from '@chakra-ui/react'
import { Btn } from '@/components/ui/Btn'
import { SectionLabel } from '@/components/typography'
import { bookingUrl } from '@/config/site'
import { useLocale } from '@/i18n'
import { padNumber } from '@/lib/padNumber'
import { PAIN_POINTS } from './painPoints.data'

/** The one full-bleed accent field on the page: the color change is the section division. */
export const PainPoints = () => {
  const { locale } = useLocale()
  const painPoints = PAIN_POINTS[locale]

  return (
    <Box
      as="section"
      id="pain"
      bg="accent"
      color="ground"
      px="clamp(20px, 4vw, 48px)"
      pt="clamp(44px, 5.5vw, 72px)"
      pb="clamp(52px, 6vw, 80px)"
    >
      <SectionLabel color="inherit" opacity={0.85} mb="48px">
        {painPoints.sectionLabel}
      </SectionLabel>
      <Grid
        templateColumns="repeat(auto-fit, minmax(min(300px, 100%), 1fr))"
        gap="clamp(32px, 4vw, 64px)"
        alignItems="end"
      >
        <Box>
          {painPoints.lines.map((line, index) => (
            <Grid
              key={line}
              borderTop="2px solid"
              borderColor="dividerOnAccent"
              py="18px"
              templateColumns="clamp(38px, 5vw, 56px) minmax(0, 1fr)"
              gap="clamp(10px, 1.4vw, 16px)"
              alignItems="baseline"
            >
              <Text
                fontFamily="heading"
                fontWeight="800"
                fontSize="15px"
                letterSpacing="0.12em"
                opacity={0.8}
              >
                {padNumber(index)}
              </Text>
              <Text
                fontFamily="heading"
                fontWeight="800"
                fontSize="clamp(20px, 1.9vw, 30px)"
                lineHeight="1.2"
                letterSpacing="-0.02em"
              >
                {line}
              </Text>
            </Grid>
          ))}
        </Box>
        <Box borderTop="2px solid" borderColor="dividerOnAccent" pt="24px">
          <Heading
            as="h3"
            mb="24px"
            fontSize="clamp(28px, 2.6vw, 44px)"
            fontWeight="800"
            lineHeight="1.08"
            letterSpacing="-0.03em"
          >
            {painPoints.closing}
          </Heading>
          <Btn
            href={bookingUrl('build', 'pain-points')}
            target="_blank"
            rel="noopener noreferrer"
            variant="ground"
            block
            fontSize="15px"
            px="20px"
            py="18px"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            display="block"
          >
            {painPoints.ctaLabel}
          </Btn>
        </Box>
      </Grid>
    </Box>
  )
}
